import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import "./InfoIcon.css";
import infoIcon from "../public/img/info.svg";
import infoIconHover from "../public/img/info_hover.svg";

const InfoIcon = ({ text }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [popupStyle, setPopupStyle] = useState({});
  const infoIconRef = useRef(null);
  const popupRef = useRef(null);

  useEffect(() => {
    // Define the function inside the effect to ensure it has the current state and refs
    const handleClickOutside = (event) => {
      if (
        infoIconRef.current &&
        !infoIconRef.current.contains(event.target) &&
        popupRef.current &&
        !popupRef.current.contains(event.target)
      ) {
        setIsVisible(false);
      }
    };

    // Attach the event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Return a cleanup function that removes the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isVisible && popupRef.current && infoIconRef.current) {
      const rect = infoIconRef.current.getBoundingClientRect();
      const popupWidth = popupRef.current.offsetWidth || 220;
      const popupHeight = popupRef.current.offsetHeight || 80;
      const viewportPadding = 12;
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      // Prefer showing above the icon; if there isn't room, place it below.
      let top = rect.top - popupHeight - 10;
      if (top < viewportPadding) {
        top = rect.bottom + 10;
      }

      // Clamp to viewport so popup never creates horizontal page overflow.
      let left = rect.left;
      if (left + popupWidth > viewportWidth - viewportPadding) {
        left = viewportWidth - popupWidth - viewportPadding;
      }
      if (left < viewportPadding) {
        left = viewportPadding;
      }

      // Also protect bottom edge for very short viewports.
      if (top + popupHeight > viewportHeight - viewportPadding) {
        top = Math.max(viewportPadding, viewportHeight - popupHeight - viewportPadding);
      }

      setPopupStyle({
        position: "fixed",
        top: `${top}px`,
        left: `${left}px`,
      });
    }
  }, [isVisible]); // <-- Recalculate position when isVisible changes

  const popup = isVisible && (
    <div
      ref={popupRef}
      className="info-popup"
      style={popupStyle} // <-- Use state for style
    >
      {text}
    </div>
  );

  return (
    <>
      <div className="info-icon-container" ref={infoIconRef}>
        <img
          src={isHovering ? infoIconHover : infoIcon}
          alt="Info"
          className="info-icon"
          onClick={() => setIsVisible(!isVisible)}
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
        />
      </div>
      {ReactDOM.createPortal(popup, document.body)}
    </>
  );
};

export default InfoIcon;
